'use strict';

/**
 * Apre una finestra popup
 * @param page
 * @param title
 * @param width
 * @param height
 * @returns {*}
 */
module.exports = function windowOpen(page, title, width, height) {
    var winl = '',
        wint = '';

    if (width) {
        winl = (screen.width - width) / 2;
    }
    if (height) {
        wint = (screen.height - height) / 2;
    }

    var params = 'toolbar=0,' +
        'location=0,' +
        'directories=0,' +
        'status=0,' +
        'menubar=0,' +
        'titlebar=0,' +
        'scrollbars=1,' +
        'resizable=0,' +
        'top=' + wint + ',' +
        'left=' + winl + ',' +
        'width=' + width + ',' +
        'height=' + height;

    return window.open(page, title, params);
};
